<template>
  <div class="info-region-container">
    <div class="all-content-container" v-allow="'0604'" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <div style="padding: 15px; border: ">
            <h3>{{ groupName }} - 大棚方案</h3>
          </div>
          <div class="table-title-btn">
            <el-button type="primary" class="adduser" @click="handleAdd">添加</el-button>
            <el-button type="primary" class="adduser" @click="handleReturn">返回决策模型</el-button>
          </div>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="模型名称">
              <template slot-scope="scope">
                <p>{{ scope.row.planName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="执行时间">
              <template slot-scope="scope">
                <p>{{ scope.row.planDate }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="累计完成时间">
              <template slot-scope="scope">
                <p>{{ scope.row.finishTime }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
              <template slot-scope="scope">
                <p v-if="scope.row.status == 0">禁用</p>
                <p v-if="scope.row.status == 1">启用</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button v-if="scope.row.status == 0" type="text" size="small"
                  @click="handleStatus(scope.row)">启用</el-button>
                <el-button v-if="scope.row.status == 1" type="text" size="small"
                  @click="handleStatus(scope.row)">禁用</el-button>
                <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next, jumper" class="pageTap"
              @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize"
              :total="total"></el-pagination>
          </div>
        </div>
        <el-dialog :title="addEditTitle" :visible.sync="addEditIsDialog" :before-close="handleCancel" width="600px" center
          style="z-index: 10000">
          <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="模型名称：" prop="planId">
                  <el-select v-model="ruleForm.planId" placeholder="请选择模型名称" clearable>
                    <el-option v-for="item in planArray" :key="item.id" :label="item.planName"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="执行时间：" prop="planDate">
                  <el-date-picker v-model="ruleForm.planDate" placeholder="请选择执行时间" type="date" value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd" clearable style="width: 100%">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10,
        groupId: "",
      },
      total: 0, // 总数
      tableData: [],
      ruleForm: {
        // 添加、编辑弹窗表单
        id: "",
        groupId: "",
        planId: "",
        planDate: "",
      },
      rules: {
        // 添加、编辑弹窗表单规则
        planId: [
          {
            required: true,
            message: "请选择模型名称",
            trigger: "change",
          },
        ],
        planDate: [
          {
            required: true,
            message: "请选择执行时间",
            trigger: "change",
          },
        ],
      },
      addEditTitle: "添加大棚方案", // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      planArray: [], // 方案数组
      groupName: "", // 大棚名称
    };
  },
  created() {
    this.groupName = this.$route.query.groupName;

    // 查询
    this.getList();

    // 获取方案列表
    this.getPlanList();
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        groupId: "",
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.searchForm.groupId = this.$route.query.groupId;
      this.$api.photosynthesis.getGroupPlanList(this.searchForm).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data;
          this.total = res.count;
          this.loading = false;
        }
      });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.photosynthesis.delGroupPlan(row.id).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true;
      this.addEditTitle = "添加大棚方案";
      this.ruleForm.id = "";
    },
    // 取消
    handleCancel() {
      this.$refs["ruleForm"].resetFields();
      this.addEditIsDialog = false;
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.ruleForm.groupId = this.$route.query.groupId;
          this.$api.photosynthesis.saveGroupPlan(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.handleCancel();
              this.handleSearch();
            }
          });
        }
      });
    },
    // 启用、禁用
    handleStatus(row) {
      this.$api.photosynthesis.noOrOffGroupPlan({ id: row.id }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.handleSearch();
        }
      });
    },
    // 获取方案列表
    getPlanList() {
      this.$api.photosynthesis.getPlanAll().then((res) => {
        if (res.code == 200) {
          this.planArray = res.data;
        }
      });
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `decisionManagement`,
        query: {},
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }


}
</style>